import React, { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Popup,
  Tooltip,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

const JamaicaCenter = [18.1096, -77.2975];

const HeatLayer = ({ points }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !points?.length) return;

    const heatPoints = points.map((point) => [
      Number(point.latitude),
      Number(point.longitude),
      1,
    ]);

    const heatLayer = L.heatLayer(heatPoints, {
      radius: 45,
      blur: 30,
      maxZoom: 18,
      minOpacity: 0.5,

      // RED HEATMAP
      gradient: {
        0.2: "#ffb3b3",
        0.4: "#ff6666",
        0.6: "#ff0000",
        0.8: "#cc0000",
        1.0: "#800000",
      },
    }).addTo(map);

    return () => {
      map.removeLayer(heatLayer);
    };
  }, [map, points]);

  return null;
};

const ZoomToMarker = ({ position }) => {
  const map = useMap();

  useEffect(() => {
    if (position) {
      map.flyTo(position, 13, {
        duration: 1.5,
      });
    }
  }, [position, map]);

  return null;
};

export default function HeatMapComponent({ data }) {
  return (
    <MapContainer
      center={JamaicaCenter}
      zoom={8}
      scrollWheelZoom={true}
      style={{
        height: "300px",
        width: "100%",
        borderRadius: "14px",
      }}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <HeatLayer points={data} />

      {data?.map((point, index) => {
        const lat = Number(point.latitude);
        const lng = Number(point.longitude);

        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          return null;
        }

        return (
          <Marker
            key={index}
            position={[lat, lng]}
            eventHandlers={{
              click: (e) => {
                e.target._map.flyTo([lat, lng], 14, {
                  duration: 1.5,
                });
              }
            }}
          >
            <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent={false}>
              <div style={{ minWidth: "180px" }}>
                <div>
                  <strong>Vehicle:</strong> {point.vehicle_name}
                </div>

                <div>
                  <strong>Latitude:</strong> {lat}
                </div>

                <div>
                  <strong>Longitude:</strong> {lng}
                </div>
              </div>
            </Tooltip>

            <Popup>
              <div style={{ minWidth: "200px" }}>
                <h4 style={{ marginBottom: "10px" }}>
                  {point.vehicle_name}
                </h4>

                <div>
                  <strong>Latitude:</strong> {lat}
                </div>

                <div>
                  <strong>Longitude:</strong> {lng}
                </div>
              </div>
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
}
